module.exports = __webpack_public_path__ + "media/images/sale_crm/module_cust-88dc22269437a93a8d30f968cb96a0ae.svg";